// Indian cities & South Korean cities for dynamic coverage pages.
export const INDIA_CITIES = [
  { slug: "delhi", name: "Delhi", state: "Delhi NCR", pin: "110001" },
  { slug: "mumbai", name: "Mumbai", state: "Maharashtra", pin: "400001" },
  { slug: "bangalore", name: "Bangalore", state: "Karnataka", pin: "560001" },
  { slug: "chennai", name: "Chennai", state: "Tamil Nadu", pin: "600001" },
  { slug: "hyderabad", name: "Hyderabad", state: "Telangana", pin: "500001" },
  { slug: "pune", name: "Pune", state: "Maharashtra", pin: "411001" },
  { slug: "ahmedabad", name: "Ahmedabad", state: "Gujarat", pin: "380001" },
  { slug: "kolkata", name: "Kolkata", state: "West Bengal", pin: "700001" },
  { slug: "lucknow", name: "Lucknow", state: "Uttar Pradesh", pin: "226001" },
  { slug: "jaipur", name: "Jaipur", state: "Rajasthan", pin: "302001" },
  { slug: "chandigarh", name: "Chandigarh", state: "Chandigarh", pin: "160001" },
  { slug: "surat", name: "Surat", state: "Gujarat", pin: "395001" },
  { slug: "nagpur", name: "Nagpur", state: "Maharashtra", pin: "440001" },
  { slug: "indore", name: "Indore", state: "Madhya Pradesh", pin: "452001" },
  { slug: "bhopal", name: "Bhopal", state: "Madhya Pradesh", pin: "462001" },
  { slug: "kochi", name: "Kochi", state: "Kerala", pin: "682001" },
  { slug: "goa", name: "Goa", state: "Goa", pin: "403001" },
  { slug: "mysore", name: "Mysore", state: "Karnataka", pin: "570001" },
  { slug: "noida", name: "Noida", state: "Uttar Pradesh", pin: "201301" },
  { slug: "gurgaon", name: "Gurgaon", state: "Haryana", pin: "122001" },
  { slug: "coimbatore", name: "Coimbatore", state: "Tamil Nadu", pin: "641001" },
  { slug: "visakhapatnam", name: "Visakhapatnam", state: "Andhra Pradesh", pin: "530001" },
  { slug: "patna", name: "Patna", state: "Bihar", pin: "800001" },
  { slug: "bhubaneswar", name: "Bhubaneswar", state: "Odisha", pin: "751001" },
  { slug: "dehradun", name: "Dehradun", state: "Uttarakhand", pin: "248001" },
  { slug: "amritsar", name: "Amritsar", state: "Punjab", pin: "143001" },
  { slug: "ranchi", name: "Ranchi", state: "Jharkhand", pin: "834001" },
  { slug: "raipur", name: "Raipur", state: "Chhattisgarh", pin: "492001" },
  // North East India
  { slug: "guwahati", name: "Guwahati", state: "Assam", pin: "781001" },
  { slug: "shillong", name: "Shillong", state: "Meghalaya", pin: "793001" },
  { slug: "imphal", name: "Imphal", state: "Manipur", pin: "795001" },
  { slug: "agartala", name: "Agartala", state: "Tripura", pin: "799001" },
  { slug: "aizawl", name: "Aizawl", state: "Mizoram", pin: "796001" },
  { slug: "kohima", name: "Kohima", state: "Nagaland", pin: "797001" },
  { slug: "itanagar", name: "Itanagar", state: "Arunachal Pradesh", pin: "791111" },
  { slug: "gangtok", name: "Gangtok", state: "Sikkim", pin: "737101" },
  { slug: "dimapur", name: "Dimapur", state: "Nagaland", pin: "797112" },
  { slug: "siliguri", name: "Siliguri", state: "West Bengal", pin: "734001" },
  // North India
  { slug: "kanpur", name: "Kanpur", state: "Uttar Pradesh", pin: "208001" },
  { slug: "agra", name: "Agra", state: "Uttar Pradesh", pin: "282001" },
  { slug: "varanasi", name: "Varanasi", state: "Uttar Pradesh", pin: "221001" },
  { slug: "prayagraj", name: "Prayagraj", state: "Uttar Pradesh", pin: "211001" },
  { slug: "meerut", name: "Meerut", state: "Uttar Pradesh", pin: "250001" },
  { slug: "ghaziabad", name: "Ghaziabad", state: "Uttar Pradesh", pin: "201001" },
  { slug: "ludhiana", name: "Ludhiana", state: "Punjab", pin: "141001" },
  { slug: "jalandhar", name: "Jalandhar", state: "Punjab", pin: "144001" },
  { slug: "jammu", name: "Jammu", state: "Jammu & Kashmir", pin: "180001" },
  { slug: "srinagar", name: "Srinagar", state: "Jammu & Kashmir", pin: "190001" },
  { slug: "shimla", name: "Shimla", state: "Himachal Pradesh", pin: "171001" },
  { slug: "faridabad", name: "Faridabad", state: "Haryana", pin: "121001" },
  { slug: "jodhpur", name: "Jodhpur", state: "Rajasthan", pin: "342001" },
  { slug: "udaipur", name: "Udaipur", state: "Rajasthan", pin: "313001" },
  { slug: "kota", name: "Kota", state: "Rajasthan", pin: "324001" },
  { slug: "ajmer", name: "Ajmer", state: "Rajasthan", pin: "305001" },
  // West India
  { slug: "nashik", name: "Nashik", state: "Maharashtra", pin: "422001" },
  { slug: "thane", name: "Thane", state: "Maharashtra", pin: "400601" },
  { slug: "aurangabad", name: "Aurangabad", state: "Maharashtra", pin: "431001" },
  { slug: "kolhapur", name: "Kolhapur", state: "Maharashtra", pin: "416001" },
  { slug: "vadodara", name: "Vadodara", state: "Gujarat", pin: "390001" },
  { slug: "rajkot", name: "Rajkot", state: "Gujarat", pin: "360001" },
  { slug: "bhavnagar", name: "Bhavnagar", state: "Gujarat", pin: "364001" },
  { slug: "gandhinagar", name: "Gandhinagar", state: "Gujarat", pin: "382010" },
  { slug: "gwalior", name: "Gwalior", state: "Madhya Pradesh", pin: "474001" },
  { slug: "jabalpur", name: "Jabalpur", state: "Madhya Pradesh", pin: "482001" },
  { slug: "ujjain", name: "Ujjain", state: "Madhya Pradesh", pin: "456001" },
  // South India
  { slug: "vijayawada", name: "Vijayawada", state: "Andhra Pradesh", pin: "520001" },
  { slug: "guntur", name: "Guntur", state: "Andhra Pradesh", pin: "522001" },
  { slug: "tirupati", name: "Tirupati", state: "Andhra Pradesh", pin: "517501" },
  { slug: "warangal", name: "Warangal", state: "Telangana", pin: "506002" },
  { slug: "madurai", name: "Madurai", state: "Tamil Nadu", pin: "625001" },
  { slug: "tiruchirappalli", name: "Tiruchirappalli", state: "Tamil Nadu", pin: "620001" },
  { slug: "salem", name: "Salem", state: "Tamil Nadu", pin: "636001" },
  { slug: "vellore", name: "Vellore", state: "Tamil Nadu", pin: "632001" },
  { slug: "mangalore", name: "Mangalore", state: "Karnataka", pin: "575001" },
  { slug: "hubli", name: "Hubli", state: "Karnataka", pin: "580020" },
  { slug: "belgaum", name: "Belgaum", state: "Karnataka", pin: "590001" },
  { slug: "thiruvananthapuram", name: "Thiruvananthapuram", state: "Kerala", pin: "695001" },
  { slug: "kozhikode", name: "Kozhikode", state: "Kerala", pin: "673001" },
  { slug: "thrissur", name: "Thrissur", state: "Kerala", pin: "680001" },
  { slug: "kollam", name: "Kollam", state: "Kerala", pin: "691001" },
  { slug: "puducherry", name: "Puducherry", state: "Puducherry", pin: "605001" },
  // East India
  { slug: "cuttack", name: "Cuttack", state: "Odisha", pin: "753001" },
  { slug: "rourkela", name: "Rourkela", state: "Odisha", pin: "769001" },
  { slug: "jamshedpur", name: "Jamshedpur", state: "Jharkhand", pin: "831001" },
  { slug: "dhanbad", name: "Dhanbad", state: "Jharkhand", pin: "826001" },
  { slug: "durgapur", name: "Durgapur", state: "West Bengal", pin: "713201" },
  { slug: "asansol", name: "Asansol", state: "West Bengal", pin: "713301" },
  { slug: "howrah", name: "Howrah", state: "West Bengal", pin: "711101" },
  { slug: "gaya", name: "Gaya", state: "Bihar", pin: "823001" },
  { slug: "muzaffarpur", name: "Muzaffarpur", state: "Bihar", pin: "842001" },
  { slug: "bhagalpur", name: "Bhagalpur", state: "Bihar", pin: "812001" },
  // Central India
  { slug: "bilaspur", name: "Bilaspur", state: "Chhattisgarh", pin: "495001" },
  { slug: "bhilai", name: "Bhilai", state: "Chhattisgarh", pin: "490001" },
  // North East India (extended)
  { slug: "silchar", name: "Silchar", state: "Assam", pin: "788001" },
  { slug: "dibrugarh", name: "Dibrugarh", state: "Assam", pin: "786001" },
  { slug: "jorhat", name: "Jorhat", state: "Assam", pin: "785001" },
  { slug: "tezpur", name: "Tezpur", state: "Assam", pin: "784001" },
];

export const KOREA_CITIES = [
  { slug: "seoul", name: "Seoul", region: "Capital Region", postal: "04524" },
  { slug: "busan", name: "Busan", region: "Yeongnam", postal: "48058" },
  { slug: "incheon", name: "Incheon", region: "Capital Region", postal: "22382" },
  { slug: "daegu", name: "Daegu", region: "Yeongnam", postal: "41911" },
  { slug: "daejeon", name: "Daejeon", region: "Chungcheong", postal: "34126" },
  { slug: "gwangju", name: "Gwangju", region: "Honam", postal: "61475" },
  { slug: "ulsan", name: "Ulsan", region: "Yeongnam", postal: "44776" },
  { slug: "jeju", name: "Jeju", region: "Jeju Province", postal: "63122" },
  { slug: "suwon", name: "Suwon", region: "Gyeonggi", postal: "16247" },
  { slug: "anyang", name: "Anyang", region: "Gyeonggi", postal: "14038" },
  { slug: "seongnam", name: "Seongnam", region: "Gyeonggi", postal: "13494" },
  { slug: "goyang", name: "Goyang", region: "Gyeonggi", postal: "10380" },
];

export const findIndiaCity = (slug) => INDIA_CITIES.find((c) => c.slug === slug);
export const findKoreaCity = (slug) => KOREA_CITIES.find((c) => c.slug === slug);
